namespace JupitersChoice {
    export class StartLogoSheenCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        
        execute(): void {
            this._componentManager.get('BaseGameLogo').play();
        }
    }
}